import axios from 'axios'

import { ENDPOINTS_BOOK } from './urls'
import { autoReplace, checkError, getCurrentUserTypeByRole } from 'utils'
import { TYPES_USER_ROLES } from 'utils/constants'

export const getUserBooks = async (isNewEndpoint = true) => {
  const url = isNewEndpoint
    ? '/bff-vle/me/userBooks'
    : ENDPOINTS_BOOK.DEPRECATED_ME_USERBOOKS
  const { data } = await axios.get(url)
  return data
}

export const getOldUserBooks = async () => {
  const url = ENDPOINTS_BOOK.ME_OLD_USERBOOS
  const { data } = await axios.get(url)
  return data
}

export const addUserBook = async ({ data, targetId, userRole }) => {
  const isRelative = targetId && userRole === TYPES_USER_ROLES.RELATIVE
  const url = isRelative
    ? `/bk/students/${targetId}/userBooks`
    : ENDPOINTS_BOOK.DEPRECATED_ME_USERBOOKS
  const response = await axios.post(url, { ...data })
  return response
}

export const deleteUserBook = async (bookId) => {
  checkError(bookId)
  const url = `/bk/userBooks/${bookId}`
  const response = await axios.delete(url)
  return response
}

export const bookInfo = async (bookId) => {
  checkError({ bookId })
  const url = `/bk/books/${bookId}`
  const { data } = await axios.get(url)
  return data
}

export const validateBookCode = async ({ isoCountry, licenseCode, userId }) => {
  checkError({ licenseCode, userId })
  const url = `/bk/licenses/${licenseCode}?userId=${userId}&isoCountry=${isoCountry}`
  const response = await axios.get(url)
  return response
}

export const downloadResourse = async ({ url }) => {
  checkError({ url })
  const response = await axios.get(url)
  return response
}

export const getCatalogueBooks = async () => {
  const url = '/bff-vle/me/userBooks/recommendations'
  const { data } = await axios.get(url)
  return data
}

export const getRecomendedBooks = async () => {
  const url = '/bff-vle/me/userBooks/recommendations/subset'
  const { data } = await axios.get(url)
  return data
}

export const postCreateUserBook = async ({ bookId, teacherId }) => {
  const url = ENDPOINTS_BOOK.TEACHERS_ID_USERBOOKS.replace(
    ':teacherId',
    teacherId
  )
  const { data } = await axios.post(url, { bookId })
  return data
}

export const postAddBook = async ({
  childBookId,
  isoCountry,
  licenseCode,
  schoolYearId,
  targetId,
  userRole,
}) => {
  const { isRelative } = getCurrentUserTypeByRole(userRole)
  const url = isRelative
    ? ENDPOINTS_BOOK.STUDENTS_ID_USERBOOKS.replace(':targetId', targetId)
    : ENDPOINTS_BOOK.ME_USERBOOKS

  const { data } = await axios.post(url, {
    childBookId,
    isoCountry,
    licenseCode,
    schoolYearId,
  })
  return data
}

export const getValidateLicense = async ({ licenseCode, userId }) => {
  const correction = {
    [':licenseCode']: licenseCode,
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_BOOK.LICENSES_ID_USER_ID, correction)
  const { data } = await axios.get(url)
  return data
}

export const getBook = async ({ bookId }) => {
  const url = ENDPOINTS_BOOK.BOOKS_ID.replace(':bookId', bookId)
  const { data } = await axios.get(url)
  return data
}

export const getBookResources = async ({ bookId, email }) => {
  const correction = {
    [':bookId']: bookId,
    [':email']: email,
  }
  const url = autoReplace(ENDPOINTS_BOOK.BOOKS_ID_MATERIALS, correction)
  const { data } = await axios.get(url)
  return data
}

export const sendRequestResource = async ({ url }) => {
  const { data } = await axios.get(url)
  return data
}

export const getArchivedBooks = async () => {
  const { data } = await axios.get(ENDPOINTS_BOOK.GET_ARCHIVED_BOOKS)
  return data
}

export const patchArchiveBook = async (userbookId) => {
  const correction = {
    [':userbookId']: userbookId,
  }
  const url = autoReplace(ENDPOINTS_BOOK.ARCHIVE_BOOK, correction)
  const { data } = await axios.patch(url)
  return data
}

export const patchUnarchiveBook = async (userbookId) => {
  const correction = {
    [':userbookId']: userbookId,
  }
  const url = autoReplace(ENDPOINTS_BOOK.UNARCHIVE_BOOK, correction)
  const { data } = await axios.patch(url)
  return data
}

export const orderBooks = async ({ userBooks, userId, userRole }) => {
  const { isStudent } = getCurrentUserTypeByRole(userRole)
  const userType = isStudent ? 'students' : 'teachers'
  const correction = {
    [':userId']: userId,
    [':userType']: userType,
  }
  const url = autoReplace(ENDPOINTS_BOOK.ORDER_BOOKS, correction)
  const { data } = await axios.post(url, { updateUserBooks: userBooks })
  return data
}
